import { render, staticRenderFns } from "./roleList.vue?vue&type=template&id=bc7635d0&scoped=true"
import script from "./roleList.vue?vue&type=script&lang=js"
export * from "./roleList.vue?vue&type=script&lang=js"
import style0 from "./roleList.vue?vue&type=style&index=0&id=bc7635d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7635d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc7635d0')) {
      api.createRecord('bc7635d0', component.options)
    } else {
      api.reload('bc7635d0', component.options)
    }
    module.hot.accept("./roleList.vue?vue&type=template&id=bc7635d0&scoped=true", function () {
      api.rerender('bc7635d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/auth/role/components/roleList.vue"
export default component.exports